// app/views/components/shared/StatusBadge.tsx
import { Badge } from '@/components/ui/badge'

const STATUS_CONFIG: Record<string, { label: string; className: string }> = {
  active: { label: 'Active', className: 'bg-green-600 text-white' },
  paused: { label: 'Paused', className: 'bg-yellow-600 text-white' },
  cancelled: { label: 'Cancelled', className: 'bg-red-600 text-white' },
  pending: { label: 'Pending', className: 'bg-orange-600 text-white' },
  responded: { label: 'Responded', className: 'bg-blue-600 text-white' },
  completed: { label: 'Completed', className: 'bg-green-600 text-white' },
}

type StatusBadgeProps = { status: string }

export function StatusBadge({ status }: StatusBadgeProps) {
  const { label, className } = STATUS_CONFIG[status] || { label: status, className: 'bg-secondary text-secondary-foreground' }
  return <Badge className={`font-normal text-xs ${className}`}>{label}</Badge>
}
